var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              _vm.submit()
            }
          }
        },
        [
          _c("step-text", [
            _vm._v(
              "Quase lá... Agora precisamos saber os dados da empresa para finalizar o cadastro."
            )
          ]),
          _vm._v(" "),
          _c("base-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|numeric|length:14",
                expression: "'required|numeric|length:14'"
              }
            ],
            attrs: {
              error: _vm.errors.first("cnpj"),
              label: "CNPJ",
              name: "cnpj",
              "data-vv-as": "CNPJ",
              mask: "##.###.###/####-##"
            },
            model: {
              value: _vm.cnpj,
              callback: function($$v) {
                _vm.cnpj = $$v
              },
              expression: "cnpj"
            }
          }),
          _vm._v(" "),
          _c("base-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|min:2|max:255",
                expression: "'required|min:2|max:255'"
              }
            ],
            attrs: {
              error: _vm.errors.first("Razão Social"),
              label: "Razão Social"
            },
            model: {
              value: _vm.company_name,
              callback: function($$v) {
                _vm.company_name = $$v
              },
              expression: "company_name"
            }
          }),
          _vm._v(" "),
          _c("base-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|min:2|max:255",
                expression: "'required|min:2|max:255'"
              }
            ],
            attrs: {
              error: _vm.errors.first("Nome Fantasia"),
              label: "Nome Fantasia"
            },
            model: {
              value: _vm.business_name,
              callback: function($$v) {
                _vm.business_name = $$v
              },
              expression: "business_name"
            }
          }),
          _vm._v(" "),
          _c("base-flex", { attrs: { align: "center", justify: "start" } }, [
            _c("label", { staticClass: "checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.terms,
                    expression: "terms"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  error: _vm.errors.first("terms"),
                  name: "terms",
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.terms)
                    ? _vm._i(_vm.terms, null) > -1
                    : _vm.terms
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.terms,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.terms = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.terms = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.terms = $$c
                    }
                  }
                }
              }),
              _vm._v("\n        Declaro que li e aceito os \n      ")
            ]),
            _vm._v(" "),
            _c(
              "small",
              {
                staticClass: "text-purple pointer",
                on: {
                  click: function($event) {
                    _vm.showModal = true
                  }
                }
              },
              [_vm._v("\n        Termos de Uso e Serviços\n      ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "base-flex",
            { staticClass: "mt-10", attrs: { justify: "end" } },
            [
              _c(
                "base-button",
                {
                  attrs: { outlined: "" },
                  on: {
                    click: function($event) {
                      _vm.prevStep()
                    }
                  }
                },
                [_vm._v("voltar")]
              ),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  attrs: {
                    type: "submit",
                    color: "green",
                    loading: _vm.loading,
                    disabled: !_vm.terms
                  }
                },
                [_vm._v("cadastrar")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "modal",
            {
              attrs: { size: "md" },
              on: {
                close: function($event) {
                  _vm.showModal = false
                }
              }
            },
            [
              _c("template", { slot: "header" }, [
                _c("img", {
                  staticClass: "logo-color",
                  attrs: {
                    src: require("../../../../../../../static/logo.svg")
                  }
                })
              ]),
              _vm._v(" "),
              _c("template", { slot: "body" }, [
                _c("div", { staticClass: "terms" }, [_c("TermsOfUse")], 1)
              ]),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [
                _c("div", { staticClass: "footer" }, [
                  _c("label", { staticClass: "checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.terms,
                          expression: "terms"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: { name: "terms", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.terms)
                          ? _vm._i(_vm.terms, null) > -1
                          : _vm.terms
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.terms,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.terms = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.terms = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.terms = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(
                      "\n          Declaro que li e aceito os Termos de Uso e Serviços\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn bg-purple-outline",
                      on: {
                        click: function($event) {
                          _vm.showModal = false
                        }
                      }
                    },
                    [_vm._v("fechar")]
                  )
                ])
              ])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3baffc96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3baffc96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUp/Steps/Accountable/Types/Legal/Legal.vue
// module id = null
// module chunks = 